//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      form: {
        id: "",
        level_pemohon: '0',
        nama: "",
        nip_nik: "",
        hp: "",
        jabatan_pemohon: "",
        jabatan_lainnya: "",
        instansi_pemohon: "",
        instansi_lainnya: "",
        email_pemohon: "",
        judul: "",
        desk_permintaan: "",
        kat_permintaan: "",
        otor_permintaan: "",
        catatan_persetujuan: "",
        createdBy: "",
        createdAt: "",
        korhub_ker: "",
        korhub_ker_At: "",
        penghub_bis: "",
        penghub_bis_At: "",
        KA_LPSE: "",
        KA_LPSE_At: "",
        status: "",
        status_korhub_ker: "",
        status_penghub_bis: "",
        status_KA_LPSE: ""
      },

      list_data: [],

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data: true,

      mdl_add: false,
      mdl_edit: false,
      mdl_hapus: false,
      btn_add: false
    };
  },
  methods: {
    getView: function() {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_MasterKategori + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          this.$store.commit("hideLoading");
          console.log(res_data);
        });
    },

    addData: function(number) {
      fetch(this.$store.state.url.URL_MasterKategori + "Add", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify(this.form)
      }).then(res_data => {
        this.Notify("Sukses Menambah Data", "primary", "check_circle_outline");
        this.getView();
      });
    },

    editData: function() {
      fetch(this.$store.state.url.URL_MasterKategori + "editData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify(this.form)
      }).then(res_data => {
        this.Notify("Sukses Merubah Data", "warning", "check_circle_outline");
        this.getView();
      });
    },

    removeData: function(E) {
      fetch(this.$store.state.url.URL_MasterKategori + "removeData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({ id: this.form.id })
      }).then(res_data => {
        this.Notify(
          "Sukses Menghapus Data",
          "negative",
          "check_circle_outline"
        );
        this.getView();
      });
    },

    selectData: function(data) {
      this.form = data;
    },

    // ====================================== PAGINATE ====================================
    Notify: function(message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500
      });
    },
    btn_prev: function() {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function() {
      this.page_first = 1;
      this.getView();
    }

    // ====================================== PAGINATE ====================================
  },

  mounted() {
    // this.getView();
  }
};
